(function() {
  $(function() {
    return window.sk_automagic = new Automagic({
      username: 'sean_knutson',
      masqueradeUser: 'NuTech Rep',
      autorun: false,
      steps: [
        {
          wait: 500,
          when: function() {
            return $('li a[data-handler="Placement"]').length > 0;
          },
          "do": function() {
            return $('li a[data-handler="Placement"]').click();
          }
        }, {
          when: function() {
            return $('#start_survey_button').length > 0;
          },
          "do": function() {
            return $('#start_survey_button').click();
          }
        }, {
          maxWaitTime: 10000,
          when: function() {
            return App.current_page.activeSubHandlers['Grower.NuTech_SPP_Handler'] != null;
          },
          "do": function() {
            return window.spp = App.current_page.activeSubHandlers['Grower.NuTech_SPP_Handler'];
          }
        }, {
          maxWaitTime: 10000,
          when: function() {
            var ref;
            return ((ref = window.spp.curStep) != null ? ref.num : void 0) === 1;
          },
          waitAnother: 500,
          "do": function() {
            $('#select_all_button').click();
            return $('#next_button').click();
          }
        }, {
          when: function() {
            var ref;
            return ((ref = window.spp.curStep) != null ? ref.num : void 0) === 2;
          },
          waitAnother: 500,
          "do": function() {
            $('.spp-tr>td:first-of-type .spp-clickable-cell').click();
            return $('#next_button').click();
          }
        }, {
          when: function() {
            var ref;
            return ((ref = window.spp.curStep) != null ? ref.num : void 0) === 3;
          },
          waitAnother: 500,
          "do": function() {
            return $('#next_button').click();
          }
        }, {
          when: function() {
            var ref;
            return ((ref = window.spp.curStep) != null ? ref.num : void 0) === 4;
          },
          waitAnother: 500,
          "do": function() {
            return $('#next_button').click();
          }
        }, {
          when: function() {
            var ref;
            return ((ref = window.spp.curStep) != null ? ref.num : void 0) === 5;
          },
          waitAnother: 500,
          "do": function() {
            $('tr:nth-of-type(1) input[data-step="5"][type="text"]').val('100');
            $('tr:nth-of-type(2) input[data-step="5"][type="text"]').val('110');
            return $('#next_button').click();
          }
        }
      ]
    });
  });

}).call(this);
